// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"pm_a bfq_rp bfq_kq bfq_kr","PostDetailRight__brandDaysPosts":"pm_b bfq_rp bfq_kq bfq_kr"};